import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import { makeStyles, Box, Button, Container, Grid, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { startAlerta } from "../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import AfiliadoTurnosService from "../../../services/AfiliadoTurnosService";
import { MOTIVO_TURNOS } from '../../../utils/constants';

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    btnConfirm: {
        marginTop: "1rem",
        textTransform:"none"
    },
    title: {
        fontWeight: "bold"
    }
}));
export const CancelarTurnoScreen = () => {
    const dispatch = useDispatch();
    const classes = useStyles()

    const { idAgenda } = useParams();
    const [ turno, setTurno ] = useState(null)
    const [ cancelacionConfirmada, setCancelacionConfirmada ] = useState(false)

    useEffect(async () => {
        try {
            dispatch(startSpinner())
            const result = await AfiliadoTurnosService.getDetalleTurno(idAgenda)
            const body = await result.json()

            if (result.ok) {
                setTurno(body);
                dispatch(finishSpinner())
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente", "error"))
            }
            console.log("Error al traer los datos del turno", error)
        }
    }, [dispatch, idAgenda])
    
    const handleCancelarTurno = async (e) => {        
        e.preventDefault();
        try {
            dispatch(startSpinner())
            const data = {
                idAgenda: idAgenda,
                idMotivoCancelacion: MOTIVO_TURNOS.CANCELADO_POR_AFILIADO,
                esAfiliado: true
            }
            const result = await AfiliadoTurnosService.cancelarTurno(data)
            const body = await result.json()
            
            if (result.ok) {
                setCancelacionConfirmada(true);
                dispatch(finishSpinner())
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error) {
                dispatch(startAlerta(error, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error al cancelar el turno. Intente nuevamente.", "error"))
            }
            console.log("Error al cancelar el turno", error)
        }
    };

    return (

        <div className={classes.root}>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    <Box p="1rem">                        
                        {!cancelacionConfirmada && (turno?.idAfiliado || turno?.idAfiliadoExterno)
                            ?
                                <>
                                    <Typography align="center" variant="h4" className={classes.title} color="secondary">
                                        Cancelar Turno
                                    </Typography>

                                    <Typography variant="body2" align="justify" style={{marginTop: "1rem", marginBottom: "1rem", fontSize: "1rem"}}>
                                        Esta seguro que desea cancelar el siguiente turno?
                                    </Typography>

                                    {turno&&
                                        <>
                                            <Grid container justify="center" spacing={0}>
                                                <Grid item xs={10}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                        <strong>Afiliado: </strong>{turno.afiliado.apellido_y_nombre}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container justify="center" spacing={0} >
                                                <Grid item xs={5}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                        <strong>Fecha: </strong>{new Date(turno.fecha).toLocaleString("es", optionsfecha)}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                        <strong>Hora: </strong>{turno.hora}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container justify="center" spacing={1}>
                                                <Grid item xs={10}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                        <strong>Profesional: </strong>{turno.efectorRed.nombreEfector}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container justify="center" spacing={1}>
                                                <Grid item xs={10}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                        <strong>Especialidad: </strong>{turno.especialidad.descripcionEspecialidades}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container justify="center" spacing={1}>
                                                <Grid item xs={10}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                        <strong>Modalidad: </strong>{turno.idTipoTurnoSol === 1 ? 'Presencial' : 'Virtual'}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container justify="center" spacing={1}>
                                                <Grid item xs={10}>
                                                    <Typography variant="h6" class="typografy" style={{margin: "5px", marginBottom: "0px"}}>
                                                        <strong>Centro Medico: </strong>{turno.centroMedico.descripcionCentro}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            {turno.idTipoTurnoSol === 1 &&
                                                <Grid container justify="center" spacing={1} style={{marginBottom: 10}}>
                                                    <Grid item xs={10}>
                                                        <Typography variant="h6" class="typografy" style={{margin: "5px"}}>
                                                            <strong>Domicilio: </strong>{turno.centroMedico.direccion}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </>
                                    }

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.btnConfirm}
                                        onClick={handleCancelarTurno}
                                    >
                                        CONFIRMAR CANCELACIÓN
                                    </Button>
                                </>
                            :
                                <Typography variant="body2" align="justify" style={{marginTop: "1rem", marginBottom: "1rem", fontSize: "1.2rem", textAlign: "center"}}>
                                    Su turno ha sido cancelado de manera exitosa.
                                </Typography>
                        }
                    </Box>
                </Container>
            </Box>
        </div>
    );
};